import gql from 'graphql-tag'

export default gql`
mutation createTracking($record: CreateOneTrackingInput!) {
  createTracking(record: $record) {
    record {
      _id
      labelId
      carrier
      code
      label {
        referenceId
        app
        recipient
      }
    }
  }
}
`




// WEBPACK FOOTER //
// ./src/graphql/mutations/createTracking.js